import * as React from 'react';
import { useContext } from 'react';
import Box from '@mui/material/Box';

import ModalDefault from './ModalDefault';
import Button from '../button/Button';

import { ModalContext } from '../../provider/ModalProvider';
import { confirm_contents } from '../../utils/modal_contents';

import { StyledModalWrapper, StyledModalTitle, StyledModalUtil, StyledLine } from '../../styles/common';
import { styled } from '@mui/material';

export const ModalConfirmButton = styled(Button)(({ theme }) => ({
  fontSize: '1.075rem',
  width: 'calc(50% - 0.5px)',
  height: '100%',
}));

// "결제대기 조회 >" 를 위한 UI
const CheckPendingPayment = styled(Box)(() => ({
  position: 'absolute',
  right: '0.75rem',
  fontSize: '0.825rem',
  top: '0.35rem',
  color: '#969696',
  cursor: 'pointer',
  userSelect: 'none',
}));

function ModalConfirm() {
  const { modal_confirm } = useContext(ModalContext);
  const isSumMoney = modal_confirm.data.title === confirm_contents['sum_money'].title;

  const onCloseModal = () => {
    if (!isSumMoney) {
      modal_confirm.data.cancle_callback ? modal_confirm.data.cancle_callback() : false;
    }
    modal_confirm.closeModalConfirm();
  };
  function onButtonClick(text: string) {
    const cancle_arr = ['취소', '따로 발송', '아니요'];
    if (cancle_arr.includes(text)) {
      modal_confirm.data.cancle_callback ? modal_confirm.data.cancle_callback() : false;
      modal_confirm.closeModalConfirm();
    } else {
      modal_confirm.data.confirm_callback();
      modal_confirm.closeModalConfirm();
    }
  }
  const onClickWaitPyament = () => {
    modal_confirm.data.payment_callback ? modal_confirm.data.payment_callback() : false;
  };

  return (
    <>
      <ModalDefault visible={modal_confirm.data.visible} onClose={onCloseModal}>
        <StyledModalWrapper>
          <StyledModalTitle dangerouslySetInnerHTML={{ __html: modal_confirm.data.title }}></StyledModalTitle>
          <StyledModalUtil>
            <ModalConfirmButton
              color={modal_confirm.data.button_type == 'normal_reverse_color' ? 'gray_1' : 'green'}
              onClick={(e: any) => {
                e.stopPropagation();
                onButtonClick(modal_confirm.data.left);
              }}
            >
              {modal_confirm.data.left}
            </ModalConfirmButton>
            <StyledLine></StyledLine>
            <ModalConfirmButton
              color={modal_confirm.data.button_type == 'normal_reverse_color' ? 'green' : 'gray_1'}
              onClick={() => onButtonClick(modal_confirm.data.right)}
            >
              {modal_confirm.data.right}
            </ModalConfirmButton>
          </StyledModalUtil>
          {isSumMoney ? (
            <CheckPendingPayment onClick={onClickWaitPyament}>{'결제대기 조회 >'}</CheckPendingPayment>
          ) : null}
        </StyledModalWrapper>
        {/* 여기에 모달 추가 시 어떻게 될까? */}
      </ModalDefault>
    </>
  );
}

export default ModalConfirm;
